module.exports = __webpack_public_path__ + "static/noun_depressed_2839144-6c1b56db5a7fc888cc14618c2e726449.svg";